<template>
    <div>
        <header-portrate />
    <div class="pa-2 m-2">
        
        <bread-crumbs :items="items"></bread-crumbs>
        <tabs-comp :tabs="tabs" />
        <v-row :style="`direction:`+lang.dir+`;margin-left: 30px;margin-right:30px;`">
            <v-col cols="12" md="12" sm="12" :class="`text-`+lang.lalgin">
                <b-button
                    v-b-toggle.add_genexpense
                    class="btn-sm btn "
                    style="margin-top:11px;width:150px;background:transparent;border:none"
                    id="multiply-button" 
                    @click="expExp()"
                    >
                    <div style="width:150px;" :class="`multiply-button-content-`+lang.lalgin">{{lang.add_general_expense}}</div>
                    
                </b-button>
                <!-- <b-button variant="success" class="btn-sm" style="width:145px;margin-right:6px;" flat v-b-toggle.add_genexpense color="success">{{lang.add_general_expense}}</b-button>
                <b-button variant="info" @click="exportE('e')" class="btn-sm" style="width:145px;margin-right:6px;">
                        {{lang.export_excel}}
                </b-button> -->

            </v-col>
        </v-row>
        <v-row :style="`direction:`+lang.dir+`;margin-left:30px;margin-right:30px;`">
            <v-data-table
                :headers="headers"
                :items="purchrows"
                :search="search"
                :items-per-page="10"
                class="elevation-1"
                :page.sync="page"
                hide-default-footer
                @page-count="pageCount = $event"
            >
            <template v-slot:item="row">
              <tr>
                <td class="text-center" style="width:100px">{{ row.item.bill_number }}</td>
                <td class="text-center" nowrap>{{ row.item.vendor }}</td>
                <td class="text-center">{{ row.item.bill_date }}</td>
                <td class="text-center">{{ row.item.total }}</td>
                <td class="text-center">{{ row.item.vat }}</td>
                <td class="text-center">{{ row.item.ftotal }}</td>
                <td class="text-center" style="width:110px;">
                  <v-btn style="font-size:0.2em;background:#902626;width:70px;color:#FFF;height:25px !important;" @click="ViewItem(row.item)">{{lang.view}}</v-btn>
                  <v-btn style="font-size:0.2em;background:red;width:70px;color:#FFF;height:25px !important;margin-right:5px;" @click="delItem(row.item)">{{lang.delete}}</v-btn>
                </td>
              </tr>
            </template>
            <template slot="body.append">
                
                    <tr>
                        <th> </th>
                        <th> </th>
                        <th style="text-align:center;font-size:1.2em;background:#ccc;font-weight:bold">{{lang.totals}}</th>
                        <th style="text-align:center;font-size:1.2em;background:#ccc;font-weight:bold">{{ptotals}}</th>
                        <th style="text-align:center;font-size:1.2em;background:#ccc;font-weight:bold">{{pvat}}</th>
                        <th style="text-align:center;font-size:1.2em;background:#ccc;font-weight:bold">{{pftotals}}</th>
                        <th></th>
                    </tr>
                
            </template>
            </v-data-table>
            <v-container style="direction:rtl">
                <div class="text-center pt-2" style="direction:rtl">
                <v-pagination
                    v-model="page"
                    value="10"
                    :length="pageCount"
                    style="direction:rtl"
                ></v-pagination>
                </div>
            </v-container>
        </v-row>
        <expenses-gen ref="expExp" />
    </div>
        <Footer />
    </div>
</template>

<script>
import breadCrumbs from '@/components/breadCrumbs.vue'
import TabsComp from '@/components/tabsComp.vue'
import axios from 'axios';
import ExpensesGen from '@/components/expenses-gen.vue';
import HeaderPortrate from '@/components/Header-Portrate.vue';
import Footer from '@/components/Footer.vue';
export default {
    components: { breadCrumbs, TabsComp, ExpensesGen, HeaderPortrate,Footer },
    data() {
        return {
            id:0,
            active_tab:2,
            search: '',
            purchrows:[],
            page: 1,
            pageCount:0,
            sdate: '',
            edate: '',
        }
    },
    created() {
        this.getInvoice();
    },
    methods: {
        expExp(){
            this.$refs.expExp.getExpense = 2;
            this.$refs.expExp.getExpType();
        },
        getInvoice(){
            const post = new FormData();
            post.append('type','getPurchase');
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]',this.id);
            post.append('data[sdate]',this.sdate);
            post.append('data[edate]',this.edate);
            post.append('data[type]',2);

            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                // console.log(res);
                this.purchrows = res.results.data;
            });
        },
        ExportIt(type){
            let url = this.$store.state.SAMCOTEC.e_path+'?';
            if(type != 'e'){
                let url = this.$store.state.SAMCOTEC.pd_path+'?inrecepit';
            }
            const post = new FormData();
            post.append('export','inrecepit');
            post.append('type',1);
            post.append('sdate','');
            post.append('edate','');
            axios.post(
                url, post
            ).then((res) => {
                var rest = res.data;
                window.open('../api' + rest.url,'_blank')
            })
        },
        exportE(type){
            let url = '';
            if(type == 'e'){
                url = this.$store.state.SAMCOTEC.e_path;
            }else{
                url = this.$store.state.SAMCOTEC.pd_path;
            }
            const myhead = this.headers;
            const mydata = this.purchrows;
            const reportname = 'فواتير المشتريات';
            const period = this.sdate + ' - ' + this.edate;
            const head = []
            const keys = []
            
            if(myhead.length > 0){
                for(let i = 0;i < myhead.length;i++){
                    head.push(myhead[i].text);
                    if(myhead[i].text != 'الاجراء')
                        keys.push(myhead[i].value);
                }
            }
            
            const post = new FormData();
            post.append("export" , 'inrecepit');
            post.append("keys",keys);
            post.append("header",head);
            if(mydata.length > 0){
                for(let i = 0;i< mydata.length;i++){
                    for(const [key, value] of Object.entries(mydata[i])){
                       post.append('data['+i+']['+key+']',value);
                    }
                }
            }
            post.append("reportname",reportname);
            post.append("period",period);
            axios.post( url , post)
            .then((res) => {
                window.open('../api/'+res.data.url,'_blank');
            })
        },
        getExpenses(){
            const post = new FormData();
            post.append("type" , "getExpenseSummary");
            post.append("auth",this.$cookies.get(this.$COOKIEPhase));
            post.append("data[sdate]",this.sdate);
            post.append("data[edate]",this.edate);
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then(
                (response) => {
                    const res = response.data;
                    ///this.exprows = res.results.data.results;
                    
                    // console.log(res);
                    this.getExpenses();
                }
            )
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                return this.$store.state.lang.en;
                }else{
                return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        headers: function() {
            return [
                {
                    text: this.lang.invoiceno,
                    align: 'center',
                    sortable: true,
                    value: 'bill_number',
                },
                {
                    text: this.lang.vendor,
                    align: 'center',
                    sortable: false,
                    value: 'vendor',
                },
                {
                    text: this.lang.inv_date,
                    align: 'center',
                    sortable: false,
                    value: 'bill_date',
                },
                {
                    text: this.lang.total,
                    align: 'center',
                    sortable: false,
                    value: 'total',
                },
                {
                    text: this.lang.vat,
                    align: 'center',
                    sortable: false,
                    value: 'vat',
                },
                {
                    text: this.lang.ftotal,
                    align: 'center',
                    sortable: false,
                    value: 'ftotal',
                },
                {
                    text: this.lang.action,
                    align: 'center',
                    sortable: false,
                }
            ]
        },
        tabs: function(){
            let t = [
                {
                    index:0,name:this.lang.chart_of_account,href:'/finance/coa',class: 'mytab3',smclass:'font-small', full: true
                },
                {
                    index:0,name:this.lang.finance_jvs,href:'/finance/jvs',class: 'mytab3',smclass:'font-small', full: true
                },
                {
                    index:0,name:'أرصدة افتتاحية',href:'/finance/fient',class: 'mytab2',smclass:'font-small', full: true
                },
                // {
                //     index:1,name:this.lang.exchange_voucher,href:'/finance/outreceipt',class: 'mytab2',smclass:'font-small'
                // },
                {
                    index:0,name:this.lang.paytypes,href:'/finance/paytypes',class: 'mytab3',smclass:'font-small', full: false
                },
                {
                    index:0,name:this.lang.fixed_assets,href:'/finance/fixed-assets',class: 'mytab3',smclass:'font-small', full: true
                },
                {
                    index:0,name:this.lang.definition,href:'/finance/definition',class: 'mytab3',smclass:'font-small', full: true
                },
                {
                    index:0,name:this.lang.expenses_summary,href:'/expenses/summary',class: 'mytab4',smclass:'font-small', full: false
                },
                {
                    index:1,name:this.lang.general_expenses,href:'/expenses/general',class: 'mytab3',smclass:'font-small', full: false
                },
                {
                    index:1,name:this.lang.exp_management,href:'/expenses/management',class: 'mytab',smclass:'font-small', full: false
                },
                {
                    index:1,name:this.lang.recurring_expensess,href:'/expenses/recurring',class: 'mytab3',smclass:'font-small', full: true
                },
            ]
          let x = [];
          for(let i=0;i<t.length;i++){
            if(t[i].full === false && this.$store.state.licenseType.onlySalesPurchase){
              x.push(t[i])
            }else if(!this.$store.state.licenseType.onlySalesPurchase){
              x.push(t[i])
            }
          }
          return x;
        },
        items: function() {
            return {
                    text: this.lang.general_expenses,
                    disabled: true,
                    to: '/expenses/summary',
                }
        },
        ptotals: function(){
            let x = 0;
            for(let i = 0;i < this.purchrows.length;i++){
                x = parseFloat(this.purchrows[i].total) + parseFloat(x);
            }
            return this.$RoundNum(x);
        },
        pvat: function(){
            let x = 0;
            for(let i = 0;i < this.purchrows.length;i++){
                x = parseFloat(this.purchrows[i].vat) + parseFloat(x);
            }
            return this.$RoundNum(x);
        },
        pftotals: function(){
            let x = 0;
            for(let i = 0;i < this.purchrows.length;i++){
                x = parseFloat(this.purchrows[i].ftotal) + parseFloat(x);
            }
            return this.$RoundNum(x);
        },
    },
}
</script>